import { gql } from '@apollo/client';

export const PROPOSAL_CREATE = gql`
  mutation ProposalCreate($input: ProposalInput!) {
    proposalCreate(input: $input) {
      id
      orderId
      contractorId
      userId
      siteVisitId
      planId
      mapResultId
      price
      currency
      comment
      timeline {
        from
        to
        unit
      }
      estimate {
        total
      }
      formPayload
      executionTimeframe
      validUntil
      payload
      notes
      status
      createdAt
      updatedAt
    }
  }
`;

export const PROPOSAL_UPDATE = gql`
  mutation ProposalUpdate($id: ID!, $input: ProposalUpdateInput!) {
    proposalUpdate(id: $id, input: $input) {
      id
      orderId
      contractorId
      userId
      siteVisitId
      planId
      mapResultId
      price
      currency
      comment
      timeline {
        from
        to
        unit
      }
      estimate {
        total
      }
      formPayload
      executionTimeframe
      validUntil
      payload
      notes
      status
      createdAt
      updatedAt
    }
  }
`;

export const PROPOSAL_DELETE = gql`
  mutation ProposalDelete($id: ID!) {
    proposalDelete(id: $id)
  }
`;
